import { mapAnswersListToFormObject } from "modules";
import {
  TriageIVMedicationForm,
  TriageIVMedicationSection,
  mapFormObjectToAnswersList,
} from "modules/charts-shared";
import {
  IvMedicationPayloadSection,
  IvMedicationSections,
  TriageIvMedicationResponse,
} from "../api";
import { Interaction } from "types";

function mapSectionToPayload({
  code,
  createdById,
  orderId,
  interactions,
  ...answers
}: TriageIVMedicationSection): IvMedicationPayloadSection {
  const mappedAnswers = mapFormObjectToAnswersList(answers);

  // Ensure brandNameMedication is always included if it exists in the form
  if (answers.brandNameMedication !== undefined) {
    const existingBrandNameIndex = mappedAnswers.findIndex(
      (answer) => answer.qCode === "brandNameMedication"
    );
    const brandNameValue =
      answers.brandNameMedication === true ||
      answers.brandNameMedication === "true"
        ? "true"
        : "false";

    if (existingBrandNameIndex >= 0) {
      mappedAnswers[existingBrandNameIndex].value = brandNameValue;
    } else {
      mappedAnswers.push({
        qCode: "brandNameMedication",
        value: brandNameValue,
      });
    }
  }

  return {
    code,
    orderId,
    interactions: (interactions as Interaction[]) || [],
    answers: mappedAnswers,
  };
}

function formToPayload(form: TriageIVMedicationForm): IvMedicationSections {
  const {
    ivMedications,
    ivStarts,
    medications,
    treatments,
    treatmentsIvStarts,
  } = form;
  const mapObjToPayloadList = (
    obj?: Record<string, TriageIVMedicationSection>
  ) => (obj ? Object.values(obj).map(mapSectionToPayload) : []);

  return {
    IVMedications: mapObjToPayloadList(ivMedications),
    IVStarts: mapObjToPayloadList(ivStarts),
    Medications: mapObjToPayloadList(medications),
    Treatments: mapObjToPayloadList(treatments),
    TreatmentsIvStarts: mapObjToPayloadList(treatmentsIvStarts),
  };
}

function responseToForm(payload: TriageIvMedicationResponse) {
  const {
    ivMedications,
    ivStarts,
    medications,
    treatments,
    treatmentsIvStarts,
  } = payload;

  const mapListToObject = (list?: TriageIVMedicationSection[]) => {
    const obj: Record<string, TriageIVMedicationSection> = {};
    list?.forEach(
      ({ code, createdById, orderId, order, answers, interactions }) => {
        if (orderId !== undefined && orderId !== null) {
          obj[orderId] = {
            code,
            createdById,
            orderId,
            order,
            interactions,
            ...mapAnswersListToFormObject(
              answers as { qCode: string; value: string }[]
            ),
          };
        }
      }
    );
    return obj;
  };

  return {
    ivMedications: mapListToObject(ivMedications),
    ivStarts: mapListToObject(ivStarts),
    medications: mapListToObject(medications),
    treatments: mapListToObject(treatments),
    treatmentsIvStarts: mapListToObject(treatmentsIvStarts),
  };
}

export { formToPayload, responseToForm };
